import React, { useEffect, useState } from "react";

import {
  deleteRoom,
  getRoomsForHostel,
} from "../../../services/OrganisationServices/hostelRoomServices";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { useParams } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst.js";
import RoomManagementForm from "./add-room-to-hostel";
const RoomsTable = () => {
  const { toggleHostelMenu } = useGlobalState();
  var { id } = useParams();

  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    modalState,
    openModal,
  } = useGlobalState();
  useEffect(() => {
 
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    return () => {};
  }, []);

  useEffect(() => {
    toggleHostelMenu(true);

    return () => {};
  }, []);

  return (
    <div>
      <MasterTable
        getTableData={getRoomsForHostel}
        tab1={"Hostel"}
        tab2={"Rooms"}
        hostelId={id}
        AddForm={RoomManagementForm}
        actions={{
          // status: true,
          edit: true,
          delete: true,
        }}
        // AddForm={AddHostelApplicationComponent}
        deleteRow={deleteRoom}
      />
    </div>
  );
};

export default RoomsTable;
